module.exports = __webpack_public_path__ + "assets/img/TaskErrorsIcon.e1c92261.svg";